import { grey, blue, green, red } from "@mui/material/colors";

const styles = {
  skeletonPrincipalContainer: {
    gap: '16px',
    display: 'flex',
    flexDirection: 'column',
    padding: "0px !important",
  },
  skeletonMainContainer: {
    display: "flex",
    padding: "0px 40px 0px 0px !important",
  },
  skeletonSecondaryContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  skeletonTertiaryContainer: {
    display: "flex",
    gap: "8px",
    padding: '0px !important'
  },
  mainContainer: {
    backgroundColor: 'white', 
    borderRadius: '1rem', 
    width: '100%', 
    padding: '10px 0px 5px 0px', 
    marginBottom: '12px', 
    gap: '10px',
  },
  activeButton: {
    minWidth: "200px",
    borderRadius: "0.5rem",
    height: "38px",
    backgroundColor: red["A400"],
    color: "white",
    "&:hover": {
      backgroundColor: red["A700"],
    },
  },
  inactiveButton: {
    minWidth: "200px",
    borderRadius: "0.5rem",
    height: "38px",
    backgroundColor: grey[500],
    color: grey[300],
  },
  badge: {
    backgroundColor: blue[50],
    minWidth: '24px',
    height: '24px',
    color: blue[700],
    fontWeight: 'bold',
    borderRadius: '12px',
    padding: '0px 12px'
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: grey[900],
  },
  statsChip: {
    fontSize: '1rem',
    color: green[500],
    marginRight: "8px",
    marginBottom: "8px",
  },
  moneyChip: {
    fontSize: '1rem',
    color: 'gray',
    marginRight: "8px",
    marginBottom: "8px",
  },
  statsIcon: {
    color: blue[500],
  },
  moneyIcon: {
    color: '#53CA98',
  },
  circleAvatar: {
    width: '60px',
    minWidth: '60px',
    height: '60px',
    marginRight: '16px',
    backgroundColor: grey[300],
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 3
  },
  iconCircleAvatar: {
    width: '46px',
    height: '60px',
    color: grey[800],
  },
  delivererDetailsContainer: {
    display: 'flex',
    justifyContent: 'spaceBetwen',
    padding: '0px !important',
  },
  delivererDetailsInfoContainer: {
    display: 'flex',
    justifyContent: 'spaceBetwen',
    padding: '0 !important',
  },
  tabContainer: {
    width: '100%',
    marginTop: '0px',
    padding: '0px'
  },
  principalContainer: {
    display: 'flex',
    justifyContent: 'center',
  }
};

export default styles;